import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

function sanitizeNextPath(raw: string): string {
  if (!raw || typeof raw !== 'string') return '/kol/dashboard';
  if (!raw.startsWith('/')) return '/kol/dashboard';
  if (raw.startsWith('//')) return '/kol/dashboard';
  return raw;
}

export default function ActionLinkLanding() {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const nextPath = useMemo(() => {
    if (typeof window === 'undefined') return '/kol/dashboard';
    const qp = new URLSearchParams(window.location.search);
    return sanitizeNextPath(qp.get('next') || '/kol/dashboard');
  }, []);

  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
      return;
    }
    if (user.role !== 'KOL') {
      navigate('/login?error=wrong_role_for_action_link', { replace: true });
      return;
    }
    navigate(nextPath, { replace: true });
  }, [user, navigate, nextPath]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 text-glass-text">
      <div className="w-full max-w-md glass-card p-6">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Redirecting you...</h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          Verifying your session and opening the requested KOL task.
        </p>
      </div>
    </div>
  );
}
